import GroupsScreen from './GroupsScreen';

export default GroupsScreen;
